import {EmiDataType} from '../../DetailsPage/redux/types';

// import { ValuesType, Optional } from 'utility-types';

export interface ISrpStoreState {
  hasData: boolean | null;
  isLoading: boolean;
  displayOverlay: boolean;
  srpConfig: ISrpConfig;
  srpData: ISrpData;
  partner: string;
  srpOfferData: ISrpOfferData;
  isSEO: boolean;
  faqs: Array<IFaqData>;
  seoData: ISrpSeoData;
}

export interface ISrpOfferData {
  (key: string): {data: Array<ISrpOfferDataItem>; error: string};
}

export interface ISrpSeoData {
  faqs: Array<IFaqData>;
  article: {
    desc: string;
    title: string;
  };
  meta: Array<object>;
  seoLinks: Array<object>;
  pageTitle: string;
  pageHeading: string;
  topContent: {
    description: string;
    title: string;
  };
  breadCrumbData: Array<object>;
  filterLinks: Array<{
    link_data: Array<object>;
    title: string;
  }>;
}

export interface ISrpOfferDataItem {
  ty?: string;
  pa?: number;
  pt?: string;
  st?: string;
}

interface IFaqData {
  q: string;
  a: string;
}

export interface ISrpConfig {
  filter?: IFilters;
  metaPartner?: string;

  s?: string; // sorting
  cur?: string; // currency
  im?: boolean;
  ibp?: string;

  hmd?: string;
  // next?: string;
  pc?: string;
  pcf?: number;
  la?: string;
  lo?: string;
  rank?: string;
  isGds?: boolean;
  overriderankvhids?: string;
  overriderankvhidName?: string;
  segmentSliderHctxIndex?: number;
  seoViewMore: boolean;
}

export interface ILocation_Search {
  id_type: string;
  loc_id: string;
  n: string;
}

export interface ISrpQueryParams {
  partner: string;
  cityName?: string;
  cityId: string;
  hotelQuery?: string;
  entityId?: string;
  metaPartner?: string;
  hquery?: string;
}

export interface ISrpData {
  city_meta_info?: ICityMetaInfo;
  data: Array<IHotelData>;
  next: string;
  error?: boolean;
}

export interface IHotelData {
  adp: number;
  ami?: [number];
  bt?: string;
  fcp: string;
  hn: string;
  hr?: number;
  hti?: number;
  l: string;
  lib: boolean;
  opr: number;
  spr: number;
  do?: number;
  pxper: number;
  rec?: number;
  rtn: string;
  si: Array<string>;
  hi: Array<ISRPHotelThumbnailImages>;
  oip?: Array<IPersuasionText>;
  bbp?: Array<IPersuasionText>;
  cp1?: Array<IPersuasionText>;
  cp2?: Array<IPersuasionText>;
  arp?: Array<IPersuasionText>;
  bpp?: Array<IPersuasionText>;
  tnc?: number;
  ofs?: string;
  cbm?: string;
  app?: Array<IPersuasionText>;
  bp?: Array<IPersuasionText>;
  tgi?: Array<number>;
  rac?: Array<number>;
  distl?: Array<string>;
  pph?: string;
  dspr?: number;
  npp?: Array<IPersuasionText>;
  af?: string[]; // list of applied filter codes
  // aci: [number];
  // cbm: string;
  // ch: string;
  // chc: string;
  // cot: string;
  // dtc: number;
  emi?: EmiDataType['emi'];
  emid?: EmiDataType['emiRates'];
  // gos_flag: number;
  gr?: number;
  grc?: number;
  gri?: number;
  // grti: number;
  // gseg: string;
  // gsv: string;
  hc: number;
  // hfe: number;
  // hmd: string;
  // ibp: string;
  // is_aa: number;
  // la: number;
  // lo: number;
  // nbi: [number];
  // ofs: string;
  // oi: [number];
  // pm: number;
  // pph: string;
  // pr: number;
  // ptl: []

  // sb: number;
  // sld: string;
  t?: string;
  // tax: number;
  // ti: number;
  ut?: string;
  rnpl?: number;
  // vi: number;
}

export interface ISRPHotelThumbnailImages {
  si: string; // for small images
  mi: string; // for medium images
}

export interface IPersuasionText {
  pt: string;
  ccd?: IPersuasionColor;
  htd?: {
    h?: string;
    ht?: Array<string>;
    ft?: string;
    hec?: IPersuasionColor;
    hoc?: IPersuasionColor;
    ic?: string;
  };
  fd?: IFilters;
  ic?: string;
  ui?: string;
}

export interface IPersuasionColor {
  tc?: string;
  bgc?: string;
}

// export interface IPtl {
//   ic: string;
//   img: [string];
//   t: string;
// }

export interface ICityMetaInfo {
  am: Array<string>;
  ata: Array<string>;
  aty: Array<string>;
  tabs: Array<string>;
  qf?: Array<IQuickFilter>;
  tl?: Array<{id: string; n: string}>;
  flt: Array<{n: string; fd: {(key: string): string}}>;
  hccm?: {[id: string]: string};
  gsm?: Array<string>;
  hcl?: Array<string>;
  dln?: Array<string>;
  // ac: [string];
  // altpx: string;
  // amc: IAmc;
  // banner_type: string;
  co: string;
  // coc: string;
  // collections: [ICollections];
  // ct: string;
  dsl: [IDsl];
  // gos_msg: string;
  // grt: [string];
  // is_ipl: number;
  // la: number;
  // lgdin: number;
  lli: {
    [K: string]: string; // values are location voyager ids of static locations used in location and hotel search filter for checkboxes
  };
  // lo: number;
  // pax: string;
  // pid_max: number;
  // pot: [IPot];
  // pxgrn: number;
  // sb: number;
  // sb_msg: string;
  // scthr: number;
  // segments: [ISegments];
  // ti: number;
  // tot: [ITot];
  // tyhc: ITyhc;
  // vcid: string;
  // vcids: [string];
  // vcidsn: [string];
}

export interface IQuickFilter {
  n: string;
  fd: IFilters;
  o?: Array<IQuickFilterItem>;
  m?: number;
}

export interface IQuickFilterItem {
  fid?: string;
  n?: string;
  c?: number;
}

export interface IFilters {
  range_ugc?: Array<number>;
  tags?: Array<string>;
  tag?: string;
  lid?: Array<string>;
  utag?: Array<IQuickFilterItem>;
  qf?: Array<IQuickFilter>;
  step_range?: Array<IStepRange>;
  star?: Array<number>;
  type?: Array<string>;
  chain?: Array<string>;
  amenities?: Array<string>;
  location_search?: Array<ILocation_Search>;
  fbfi?: number;
  pah?: number;
  isrnpl?: number;
  fcp?: number;
  ht?: string;
}

export interface IStepRange {
  min: number;
  max: number;
}

export interface IUpdateSeoFlags {
  isSEO: boolean;
  seoViewMore: boolean;
}

// export interface ITyhc {
//   (key: string): number;
// }

// export interface ISegments {
//   desc: string;
//   img: string;
//   slug: string;
//   st: string;
//   t: string;
// }

// export interface ITot {
//   oi: string;
//   ot: string;
// }

// export interface IPot {
//   oi: string;
//   ot: string;
// }

export interface IDsl {
  n: string;
  ahc: number;
}

export type IHotelDataType = 'SegmentSlider' | 'SignUpBanner' | 'SmartEngageBanner';

export type ISrpHotelCardPersuasionTypes =
  | 'abovePricePersausion'
  | 'bannerPersuasion'
  | 'belowBannerPersuasion'
  | 'contentPersuasion1'
  | 'contentPersuasion2'
  | 'aboveRatePlanPersuasion'
  | 'customLocation'
  | 'belowPricePersuasion';

// export interface IAmc {
//   (key: string): number;
// }

// export interface ILli {
//   (key: string): number;
// }

// export interface ICollections {
//   desc: string;
//   img: string;
//   slug: string;
//   st: string;
//   t: string;
// }
export const UPDATE_SRP_CONFIG = 'UPDATE_SRP_CONFIG';
export const FETCH_SRP_DATA = 'FETCH_SRP_DATA';
export const UPDATE_FILTER = 'UPDATE_FILTER';
export const RESET_FILTER = 'RESET_FILTER';
export const TOGGLE_LOADING = 'TOGGLE_LOADING';
export const RESET_SRP_DATA = 'RESET_SRP_DATA';
export const UPDATE_SRP_OFFER_DATA = 'UPDATE_SRP_OFFER_DATA';
export const UPDATE_SEO_FLAGS = 'UPDATE_SEO_FLAGS';
export const UPDATE_SRP_SEO_DATA = 'UPDATE_SRP_SEO_DATA';
export interface IUpdate_Srp_Config {
  type: typeof UPDATE_SRP_CONFIG;
  actionData: ISrpConfig;
}

export interface IUpdate_Srp_Offer_Data {
  type: typeof UPDATE_SRP_OFFER_DATA;
  actionData: ISrpOfferData;
}

export interface IFetch_Srp_Data {
  type: typeof FETCH_SRP_DATA;
  actionData: ISrpData;
  loadingMore?: boolean;
}
export interface IToggle_Loading {
  type: typeof TOGGLE_LOADING;
  isLoading: ISrpStoreState['isLoading'];
  displayOverlay: ISrpStoreState['displayOverlay'];
}

export interface IUpdate_Filter {
  type: typeof UPDATE_FILTER;
  actionData: IFilters;
}

export interface IReset_Filter {
  type: typeof RESET_FILTER;
}

export interface IReset_Srp_Data {
  type: typeof RESET_SRP_DATA;
}

export interface IUpdate_SEO_Flags {
  type: typeof UPDATE_SEO_FLAGS;
  actionData: IUpdateSeoFlags;
}

export interface IUpdate_Srp_Seo_Data {
  type: typeof UPDATE_SRP_SEO_DATA;
  actionData: ISrpSeoData;
}

export type SrpActionTypes =
  | IUpdate_Srp_Config
  | IFetch_Srp_Data
  | IUpdate_Filter
  | IToggle_Loading
  | IReset_Filter
  | IReset_Srp_Data
  | IUpdate_Srp_Offer_Data
  | IUpdate_SEO_Flags
  | IUpdate_Srp_Seo_Data;
